var _g, _path, _g2, _path2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPartnerInsights = function SvgPartnerInsights(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7510_3970)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7510_3970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6447 54.4767C47.2192 54.1776 47.9029 54.1753 48.4794 54.4703L75.3444 68.2196C76.7962 68.9626 76.7962 71.0374 75.3444 71.7804L48.4794 85.5297C47.9029 85.8247 47.2192 85.8224 46.6447 85.5233L20.2312 71.774C18.7958 71.0269 18.7958 68.9731 20.2312 68.226L46.6447 54.4767Z",
    fill: "black",
    fillOpacity: 0.01
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7510_3970",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 12,
    width: 64,
    height: 72
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 13.1547C47.2376 12.4402 48.7624 12.4402 50 13.1547L77.177 28.8453C78.4146 29.5598 79.177 30.8803 79.177 32.3094V63.6906C79.177 65.1197 78.4146 66.4402 77.177 67.1547L50.0001 82.8453C48.7624 83.5598 47.2376 83.5598 46 82.8453L18.8239 67.1547C17.5864 66.4402 16.824 65.1197 16.824 63.6907L16.8232 32.3095C16.8231 30.8804 17.5855 29.5598 18.8232 28.8453L46 13.1547Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7510_3970)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 48.0372 12)",
    fill: "url(#paint0_linear_7510_3970)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.5,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 48.4702 12.25)",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 48.0372 48)",
    fill: "url(#paint1_linear_7510_3970)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.433013,
    y: 0.25,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 48.0952 48.2165)",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 16.8611 30)",
    fill: "url(#paint2_linear_7510_3970)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.433013,
    y: 0.75,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 16.9191 29.7835)",
    stroke: "white",
    strokeOpacity: 0.4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4999 14.0205C47.428 13.4847 48.5717 13.4847 49.4999 14.0205L76.6766 29.7109C77.6048 30.2468 78.1766 31.2378 78.1766 32.3096V63.6904C78.1766 64.7622 77.6048 65.7532 76.6766 66.2891L49.4999 81.9795C48.5717 82.5153 47.428 82.5154 46.4999 81.9795L19.3241 66.2891C18.3959 65.7532 17.8241 64.7622 17.8241 63.6904L17.8231 32.3096C17.8231 31.2377 18.3949 30.2468 19.3231 29.7109L46.4999 14.0205Z",
    stroke: "white",
    strokeWidth: 2
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7510_3970)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9381 51.6304C56.5165 51.9263 56.1831 52.304 55.9061 52.7998C55.687 53.1917 55.5558 53.5548 55.4641 54.0232L55.4212 54.2424L55.4212 61.5121C55.4212 69.3734 55.4151 68.9014 55.5215 69.1864C55.6002 69.397 55.7075 69.5244 55.8962 69.6313C56.1455 69.7725 56.3799 69.7851 56.7601 69.6774L56.9285 69.6297L63.2536 65.9779L69.5786 62.3262L69.7654 62.1588C70.0927 61.8655 70.3135 61.5852 70.5381 61.1778C70.7491 60.7952 70.8769 60.4378 70.9667 59.979L71.0096 59.7597L71.0096 52.457L71.0096 45.1544L70.958 44.9685C70.8677 44.6428 70.7353 44.4643 70.4948 44.3438C70.2729 44.2326 70.033 44.2255 69.6808 44.3194L69.5214 44.362L63.2631 47.9728C59.8211 49.9587 56.9749 51.6047 56.9381 51.6304ZM56.923 52.8918C56.7352 53.0589 56.6119 53.2698 56.5313 53.5623L56.4897 53.7137L56.4847 58.6508L56.4797 63.5879L58.1733 60.6586C59.5165 58.3352 59.886 57.7078 59.9598 57.625C60.0276 57.5491 60.0869 57.5011 60.1797 57.4476C60.4188 57.3095 60.3842 57.2964 61.5508 57.9684L62.6051 58.5758L64.3842 55.4946L66.1633 52.4133L65.242 52.9452C64.2428 53.5221 64.2679 53.5103 64.108 53.4752C64.0689 53.4667 64.0097 53.4261 63.9762 53.3854C63.8973 53.2889 63.8777 53.0645 63.9313 52.8714C63.9772 52.7063 64.0915 52.5022 64.2128 52.3688L64.3125 52.2592L65.9439 51.3174L67.5752 50.3755L67.6844 50.3744C67.7445 50.3737 67.8234 50.3962 67.8599 50.4243C67.9905 50.5252 67.9854 50.4406 67.9854 52.4958C67.9854 54.5631 67.9914 54.463 67.8528 54.7247C67.7447 54.9289 67.6243 55.061 67.4607 55.1551C67.239 55.2824 67.0583 55.2548 66.967 55.0794C66.9277 55.0041 66.9263 54.9685 66.9206 53.9381L66.9149 52.8746L64.9268 56.3152C63.5371 58.7202 62.9129 59.7861 62.8529 59.8566C62.7385 59.9908 62.5 60.1337 62.3854 60.1367C62.3352 60.1381 61.9476 59.9315 61.2499 59.5314L60.1908 58.9239L58.3348 62.1384L56.4788 65.3531L56.4843 66.7374L56.4897 68.1217L56.5518 68.2315C56.6227 68.3568 56.7374 68.3975 56.919 68.3617C57.0194 68.3419 57.2922 68.1861 63.254 64.7441L69.484 61.1471L69.6101 61.0027C69.7541 60.8376 69.8468 60.6517 69.9066 60.4076C69.9396 60.2726 69.9411 59.9567 69.9411 53.0734L69.9411 45.8804L69.8797 45.7719C69.8098 45.6482 69.713 45.6098 69.5349 45.6348L69.426 45.6501L63.2249 49.2261C57.9059 52.2936 57.0096 52.8149 56.923 52.8918Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7510_3970",
    x: 3.15466,
    y: 38.2507,
    width: 89.2786,
    height: 63.4985,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.835294 0 0 0 0 0.737255 0 0 0 0 0.211765 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7510_3970"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_7510_3970",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7510_3970",
    x1: -0.267884,
    y1: 0.267885,
    x2: 35.7321,
    y2: 0.267886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5BC36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7510_3970",
    x1: -0.535769,
    y1: -0.267884,
    x2: 36.8338,
    y2: -0.136971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5BC36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7510_3970",
    x1: 17.2767,
    y1: -10.1384,
    x2: 43.4682,
    y2: -1.59252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5BC36"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7510_3970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7510_3970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 52.8231 51)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPartnerInsights);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "partner_insights.b522250201798e542ca96f57b03beb87.svg";